import React, { useRef } from 'react';
import LeadForm from '../components/LeadForm';
import { leadFormFields } from '../data/siteContent';

export default function Contact() {
  const formRef = useRef(null);

  return (
    <div className="bg-white min-h-screen py-20 px-6">
      <div className="max-w-6xl mx-auto space-y-12">
        <section className="space-y-4 text-center">
          <p className="text-sm uppercase tracking-[0.4em] text-gray-500">Contact</p>
          <h1 className="text-4xl font-bold text-charcoal">Schedule your strategy assessment</h1>
          <p className="text-gray-600">
            We respond within 24 hours. Email, call, or fill out the form below and we will coordinate a time that suits your team.
          </p>
        </section>

        <section className="grid gap-6 md:grid-cols-3">
          <article className="rounded-2xl border border-gray-200 bg-gray-warm p-6">
            <p className="text-sm font-semibold text-gray-500">Phone</p>
            <p className="mt-2 text-lg text-charcoal">(347) 555-0101</p>
            <p className="text-xs text-gray-500">Mon–Fri, 9am–6pm ET</p>
          </article>
          <article className="rounded-2xl border border-gray-200 bg-gray-warm p-6">
            <p className="text-sm font-semibold text-gray-500">Email</p>
            <p className="mt-2 text-lg text-charcoal">hello@taxstrategycenter.com</p>
            <p className="text-xs text-gray-500">Secure intake link included in response</p>
          </article>
          <article className="rounded-2xl border border-gray-200 bg-gray-warm p-6">
            <p className="text-sm font-semibold text-gray-500">Offices</p>
            <p className="mt-2 text-lg text-charcoal">New York & Charlotte</p>
            <p className="text-xs text-gray-500">By appointment only</p>
          </article>
        </section>

        <div ref={formRef}>
          <LeadForm
            funnelId="funnel_tax_contact"
            pageId="contact"
            ctaId="cta_contact_form"
            fields={leadFormFields}
            branding={{ primary_color: '#1e40af', secondary_color: '#AEFFE3' }}
          />
        </div>
      </div>
    </div>
  );
}
